import { DynamicFormField } from '../dynamic-form-field.model';
import { DynamicFormFieldConfig } from '../dynamic-form-field-config.model';
import { FormArray, FormGroup } from '@angular/forms';
import { DynamicNumberFieldComponent } from '../../../components/dynamic-form/dynamic-form-field';

export class NumberField extends DynamicFormField {
  constructor(config: DynamicFormFieldConfig, parentForm: FormGroup | FormArray) {
    super(config, parentForm);
    this.component = DynamicNumberFieldComponent;
  }

  static override create(config: DynamicFormFieldConfig, parentForm: FormGroup | FormArray) {
    return new NumberField(config, parentForm);
  }
}
